import { AiOutlineCalendar } from "react-icons/ai";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { IoDiamondOutline } from "react-icons/io5";
import { MdSchool } from "react-icons/md";
import styles from "./scholarship_box.module.scss";

const ScholarshipBox = ({
  title,
  courseLevel,
  specialization,
  value,
  deadline,
  externalLink,
  eligibility,
}) => {
  return (
    <div className={styles.scholarship_box}>
      <div className={styles.top}>
        <div className={styles.title}>{title || "title"}</div>
        <div className={styles.type}>
          <IoDiamondOutline />
          <span>{courseLevel || ""}</span>
        </div>
        <div className={styles.applicant}>
          <MdSchool />
          <span>{specialization || ""}</span>
        </div>
      </div>
      <div className={styles.middle}>
        <div className={styles.value_and_deadline}>
          <div className={styles.heading}>Value</div>
          <div className={styles.wrapper}>
            <span>
              <FaRegMoneyBillAlt />
            </span>
            <span>{value || ""}</span>
          </div>
        </div>
        <div className={styles.value_and_deadline}>
          <div className={styles.heading}>Deadline</div>
          <div className={styles.wrapper}>
            <span>
              <AiOutlineCalendar />
            </span>
            <span>{deadline?.substring(0, 10) || ""}</span>
          </div>
        </div>
        <div className={styles.value_and_deadline}>
          <div className={styles.heading}>Eligibility</div>
          <div className={styles.wrapper}>
            <span>
              <AiOutlineCalendar />
            </span>
            <span>{eligibility || ""}</span>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <a
          href={externalLink || "#"}
          className="btn btn-secondary"
          target="_blank"
        >
          Apply Now
        </a>
      </div>
    </div>
  );
};

export default ScholarshipBox;
